/* eslint-disable consistent-return */
import { Box, Step, StepConnector, StepIcon, StepLabel, Stepper, withStyles } from '@material-ui/core';
import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

const QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  active: {
    '& $line': {
      borderColor: '#498B35',
    },
  },
  completed: {
    '& $line': {
      borderColor: '#175317',
    },
  },
  line: {
    borderColor: '#D9D9D9',
    borderTopWidth: 5,
    borderRadius: 1,
  },
})(StepConnector);

const ColorlibStepIcon = withStyles({
  root: {
    color: '##A7A6A7',
    '&$active': {
      color: '#498B35',
    },
    '&$completed': {
      color: '#498B35',
    },
    '& .MuiStepIcon-text': {
      fontSize: '12.938px',
      fill: '#fff',
      fontWeight: '700',
    }
  },
  active: {},
  completed: {},
})(StepIcon);

const ColorlibStepLabel = withStyles({
  label: {
    marginTop: '4px !important',
  },
  active: {
    color: '#000 !important',
    fontWeight: 'bold !important',
  },
  completed: {
    color: '#000 !important',
    fontWeight: 'bold !important',
  },
})(StepLabel);

export const DenunciaStepper = ({ idEstatusDenuncia }) => {
  const { catalogs } = useSelector(state => state.catalogReducer);

  const activeStep = useMemo(() => {
    if (idEstatusDenuncia == null) return 0;
    return idEstatusDenuncia - 1;
  }, [idEstatusDenuncia]);

  const steps = useMemo(() => {
    if (!catalogs?.estatus || catalogs?.estatus.length === 0) return [];
    return catalogs?.estatus.map(item => ({
      label: item.value,
      value: item.id,
    }));
  }, [catalogs?.estatus]);
  const lastStep = useMemo(() => {
    return steps.length > 0 ? steps[steps.length - 1].value : null;
  }, [steps]);

  const isCompleted = useCallback(
    stepValue => {
      if (activeStep == null) return false;
      if (stepValue === lastStep) {
        return activeStep + 1 === lastStep;
      }
      return activeStep + 1 >= stepValue;
    },
    [activeStep, lastStep]
  );

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
      }}
    >
      <Stepper
        alternativeLabel
        activeStep={activeStep}
        connector={<QontoConnector />}
        style={{ width: '100%', height: '100%' }}
      >
        {steps.map(step => (
          <Step key={step.value} completed={isCompleted(step.value)}>
            <ColorlibStepLabel StepIconComponent={ColorlibStepIcon}>{step.label}</ColorlibStepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};
